import React, { useEffect, useState } from "react";
import {
  DATE_RANGE_PRESETS,
  detectPresetFromRange,
  getPresetDateRange,
} from "../utils/rideReportDatePresets";

const RideReportDateFilters = ({ startDate = "", endDate = "", onChange }) => {
  const [dateRangePreset, setDateRangePreset] = useState("");

  useEffect(() => {
    setDateRangePreset(detectPresetFromRange(startDate, endDate));
  }, [startDate, endDate]);

  const handlePresetChange = (preset) => {
    setDateRangePreset(preset);
    if (!preset) return;
    const range = getPresetDateRange(preset);
    if (range && typeof onChange === "function") {
      onChange(range);
    }
  };

  const handleStartChange = (value) => {
    setDateRangePreset("");
    onChange?.({ startDate: value, endDate });
  };

  const handleEndChange = (value) => {
    setDateRangePreset("");
    onChange?.({ startDate, endDate: value });
  };

  return (
    <>
      <div className="min-w-0">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Date Range
        </label>
        <select
          value={dateRangePreset}
          onChange={(e) => handlePresetChange(e.target.value)}
          className="border rounded-lg px-3 py-2 w-full bg-white"
        >
          {DATE_RANGE_PRESETS.map((preset) => (
            <option key={preset.value || "custom"} value={preset.value}>
              {preset.label}
            </option>
          ))}
        </select>
      </div>
      <div className="min-w-0">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Start Date
        </label>
        <input
          type="date"
          className="border rounded-lg px-3 py-2 w-full"
          value={startDate}
          onChange={(e) => handleStartChange(e.target.value)}
        />
      </div>
      <div className="min-w-0">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          End Date
        </label>
        <input
          type="date"
          className="border rounded-lg px-3 py-2 w-full"
          value={endDate}
          min={startDate || undefined}
          onChange={(e) => handleEndChange(e.target.value)}
        />
      </div>
    </>
  );
};

export default RideReportDateFilters;
